/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import RTCModel from '@/models/rtc';
import MeetingModel from '@/models/meeting';
import UserModel from '@/models/user';
import s from './index.less';
import { useClickAway, useMount } from 'ahooks';
import ReactionModel from '@/models/reaction';
import { meeting } from '@/models';
import EmojList from './components/EmojList';
import HandUpBtn from './components/HandUpBtn';
import { HandUpStatus } from '../EmoJ';

interface ReactionPanelProps {
  meeting?: MeetingModel;
  reaction?: ReactionModel;
  hostEnableEmoList: boolean;
  user?: UserModel;
}
const ReactionPanel: React.FC<ReactionPanelProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    reaction: store.reaction,
    user: store.user,
  };
})(
  observer((props) => {
    const { reaction, hostEnableEmoList, user } = props;
    const { formatMessage } = useIntl();
    const panelRef = useRef<any>();
    const [panelClose, setPanelClose] = useState<boolean>(false);
    const userYuxid = user?.yxuid || '';
    useClickAway((e: any) => {
      if (document.getElementById('reactionBtn')?.contains(e.target)) {
        return;
      }
      if (reaction?.handUp) {
        reaction.setCancelHanupVisible(true);
        return;
      } else {
        reaction?.setReactionVisible(false);
      }
    }, panelRef);

    useEffect(() => {
      const info = meeting?.reactionData[userYuxid];
      if (info) {
        if (info.isHandup === HandUpStatus.off) {
          reaction?.setHanUp(false);
          if (reaction?.cancelHanupVisible) {
            reaction?.setReactionVisible(false);
            reaction.setCancelHanupVisible(false);
          }
        }
      }
    }, [meeting?.reactionData[userYuxid], userYuxid]);

    const handleUp = () => {
      if (!reaction?.handUp) {
        API.api.reaction.handUp.request({}, { channelId: meeting?.info?.channelId }).then((res) => {
          reaction?.setHanUp(true);
        });
      } else {
        API.api.reaction.selfHandDown
          .request({}, { channelId: meeting?.info?.channelId })
          .then((res) => {
            reaction?.setHanUp(false);
          });
      }
    };
    useEffect(() => {
      console.log('---panelClose', panelClose);
    }, [panelClose]);

    const handUpClick = () => {
      setPanelClose(true);
      reaction?.setReactionVisible(false);
      reaction?.setCancelHanupVisible(false);
      handleUp();
      setTimeout(() => {
        setPanelClose(false);
      }, 500);
    };

    return (
      <>
        {reaction?.cancelHanupVisible && <HandUpBtn handUp={handUpClick}></HandUpBtn>}
        {!reaction?.cancelHanupVisible && !panelClose && (
          <div
            className={classnames(s.reactionPanel)}
            ref={panelRef}
            onClick={(e) => {
              e.nativeEvent.stopImmediatePropagation();
            }}
          >
            {meeting?.ableAppsMap.EmoticonReaction && (
              <EmojList hostEnableEmoList={hostEnableEmoList} />
            )}
            <span
              className={classnames(s.handUp, reaction?.handUp ? s.isActive : '')}
              onClick={() => handleUp()}
            >
              <img
                src={reaction?.handupSetting?.handUpStaticWebp}
                alt={formatMessage({ id: 'handup' })}
                className={s.hand}
                title={formatMessage({ id: 'handup' })}
              />
              <span className={s.text}>
                {reaction?.handUp
                  ? formatMessage({ id: 'handoff' })
                  : formatMessage({ id: 'handup' })}
              </span>
            </span>
          </div>
        )}
      </>
    );
  })
);
export default ReactionPanel;
